import { ClientProxy } from '../../../../../base/proxy/clientProxy'

// Sepet kredisi filtre
export interface BasketCreditListFilter {
  StartDate?: string
  EndDate?: string
  Status?: string
  OrderId?: string
  DealerCode: string
}

// Sepet kredisi response
export interface BasketCreditListResponse {
  Items: any[]
  TotalCount: number
  PageNumber?: number
  PageSize?: number
  Statistics?: {
    TotalCount: number
    PendingCount: number
    ApprovedCount: number
    RejectedCount: number
    CancelledCount?: number
    ExpiredCount?: number
  }
}

export class GetBasketCreditListApi extends ClientProxy {
  constructor(props: any = {}) {
    super({
      url: 'compay-payment/basket-credit-list',
      ...props,
    })
  }

  public async getCreditList(filter: BasketCreditListFilter): Promise<BasketCreditListResponse> {
    return await this.postAsync<BasketCreditListResponse>(filter)
  }
}
